<template>
  <Head title="Log in" />

  <div class="flex flex-col gap-y-5">
    <BreezeValidationErrors />

    <BreezeStatusMessage v-if="status">{{ status }}</BreezeStatusMessage>

    <form
      @submit.prevent="submit"
      class="flex flex-col gap-y-5"
    >
      <div>
        <BreezeLabel
          for="email"
          value="Email"
          class="sr-only"
        />
        <BreezeInput
          id="email"
          type="email"
          v-model="form.email"
          required
          autofocus
          autocomplete="off"
          placeholder="Email address"
        />
      </div>

      <div>
        <BreezeLabel
          for="password"
          value="Password"
          class="sr-only"
        />
        <BreezeInput
          id="password"
          type="password"
          v-model="form.password"
          required
          autocomplete="off"
          placeholder="Password"
        />
      </div>

      <div class="flex justify-end">
        <BreezeButton
          :class="{ 'opacity-25': form.processing }"
          :disabled="form.processing"
        >
          Login
        </BreezeButton>
      </div>
    </form>
  </div>
</template>

<script>
import BreezeButton from '@/Components/Auth/Button.vue'
import BreezeCheckbox from '@/Components/Auth/Checkbox.vue'
import BreezeGuestLayout from '@/Layouts/Guest.vue'
import BreezeInput from '@/Components/Auth/Input.vue'
import BreezeLabel from '@/Components/Auth/Label.vue'
import BreezeValidationErrors from '@/Components/Auth/ValidationErrors.vue'
import BreezeStatusMessage from '@/Components/Auth/StatusMessage.vue'
import { Head, Link } from '@inertiajs/vue3'

export default {
  layout: BreezeGuestLayout,

  components: {
    BreezeButton,
    BreezeCheckbox,
    BreezeInput,
    BreezeLabel,
    BreezeValidationErrors,
    BreezeStatusMessage,
    Head,
    Link
  },

  props: {
    canResetPassword: Boolean,
    status: String,
    redirectUrl: {
      type: String,
      default: null
    }
  },

  created() {
    if (this.redirectUrl) {
      window.location = this.redirectUrl
    }
  },

  watch: {
    redirectUrl(newVal, oldVal) {
      if (newVal) {
        window.location = newVal
      }
    }
  },

  data() {
    return {
      form: this.$inertia.form({
        email: '',
        password: '',
        remember: false
      })
    }
  },

  methods: {
    submit() {
      this.form.post(this.route('external.doc360.login'), {
        onFinish: () => this.form.reset('password')
      })
    }
  }
}
</script>
